import React, { ReactElement } from 'react';
import RecordLayout, { RecordLayoutProps } from './RecordLayout';
import { AttendeeStatus, BaseHistoryEntryData, PersonData, TaskData } from 'nekst-api';
import PersonLink from './PersonLink';
import { HistoryEventIconType } from './HistoryEventIcon';
import TaskLink from './TaskLink';

export interface EventSentData extends BaseHistoryEntryData {
  attendees: {
    person?: PersonData,
    email: string
    status: AttendeeStatus,
  }[],
  dueDate: {
    date: string,
    time?: string
    endTime?: string
  },
  task: TaskData
}

export default function EventSentRecordLayout(props: RecordLayoutProps<EventSentData>) {

  const recipients: ReactElement[] = [];

  props.record.data.attendees.forEach((attendee) => {
    if (attendee.person) {
      recipients.push(<PersonLink key={`recipient-${attendee.person.id}`} person={attendee.person} />);
    } else {
      recipients.push(<span key={`recipient-${attendee.email}`}>{attendee.email}</span>);
    }
  });

  const splitWithCommas = (value: React.ReactElement[]) => {
    const result: React.ReactElement[] = [];

    value.forEach((recipient, index) => {
      result.push(recipient);
      if (index !== recipients.length - 1) {
        result.push(<React.Fragment key={`${recipient.key}-separator`}>, </React.Fragment>);
      }
    });

    return result;
  };

  return (
    <RecordLayout
      text={(
        <>
          <PersonLink person={props.record.data.person!} />
          {' sent the event '}
          <TaskLink task={props.record.data.task} project={props.record.data.project} />
          {' invitation to the recipient(s) '}
          {splitWithCommas(recipients)}
        </>
      )}
      date={props.record.when}
      iconType={HistoryEventIconType.EVENT_SENT}
    />
  );
}
